import { CustomComponentManager, RuntimeComponent, VirtualChildComponent } from '@easytwin/runtime';
import { SubItemOutlined, AdditionalLayersOutlined, Icon } from '@easyv/react-icons';
import * as React from 'react';

export function getComponentIcon(comp: RuntimeComponent): React.ReactNode {
  const Icon = comp.scene.engine
    .getManager(CustomComponentManager)
    .getUI(comp.type, comp.version, comp.constructor.name)?.icon as Icon;

  if (Icon) return <Icon size={16} />;

  if (comp instanceof VirtualChildComponent) return <SubItemOutlined size={16} />;

  return <AdditionalLayersOutlined size={16} />;
}
